export default __webpack_public_path__ + "ff9ca6fe06d1f5fb09917ce2582301f5.png";